const servers = 20396;
const capacity = 23863.32;
const countries = 148;
const locations = 194;
export { servers, capacity, countries, locations };
